import React from "react";
import "./tcp.scss";
import Navbar from "../../components/Navbar/navbar";
import Footer from "../../components/Footer/footer";

const PrivacyPolicy = () => {
const PrivacyInfo = [
  "Account Info: minimal registration data : name, date of birth, gender, location, email or organization domain for verification.",
  "Profile Preferences: topics of interest, location filters, and demographic ranges (not publicly visible)."
];
const PrivacyUse = [
   "To operate and improve Orter’s features",
   "To help you connect with users and organizations that fit your preferences",
   "To respond to support requests and ensure safety",
   "To comply with legal obligations if required"
];
const PrivacyRights = [
  "Access or correct your data",
  "Delete your account anytime (which erases stored data)",
  "Request information about how your data is used by emailing founder@orter.co"
];
  return (
    <>
    <Navbar />
    <div className="termsAndConditions fadeIn">
      <h1 className="termsAndConditionsHeading">Privacy Policy</h1>
      <h4 className="spangleWelcome">Welcome to Orter</h4>

      <p className="termsParagraphIntro">
        <strong>Effective Date: </strong>October 2025<br/><br/>
        Orter values your privacy and is committed to protecting your personal data. 
        <br />This Privacy Policy explains how we collect, use, and protect information.
      </p>

      {/* Section 1 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn blue">1.</span>
          <span className="st blue">Information We Collect</span>
        </h4>
        {PrivacyInfo.map((detail, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">{detail}</p>
            <div className="secionLine lineColorBlue"></div>
          </div>
        ))}
      </div>

      {/* Section 2 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn orange">2.</span>
          <span className="st orange">How We Use Information</span>
        </h4>
        {PrivacyUse.map((detail, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">{detail}</p>
            <div className="secionLine lineColorOrange"></div>
          </div>
        ))}
      </div>

      {/* Section 3 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn lightGreen">3.</span>
          <span className="st lightGreen">Data Protection</span>
        </h4>

        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
              All data is encrypted in transit and at rest. Access is limited to authorized personnel under confidentiality agreements.
            </p>
            <div className="secionLine lineColorGreen"></div>
          </div>
        ))}
      </div>

      {/* Section 4 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn purple">4.</span>
          <span className="st purple">Third Parties</span>
        </h4>

        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
              We do <strong>not</strong> sell, rent, or trade user data. Limited third-party
              tools may be used for analytics or hosting but cannot access identifiable information.
            </p>
            <div className="secionLine lineColorPurple"></div>
          </div>
        ))}
      </div>

      {/* Section 5 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn gold">5.</span>
          <span className="st gold">User Rights</span>
        </h4>
        <p className="spl">
          You can:
        </p>

        {PrivacyRights.map((detail, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">{detail}</p>
            <div className="secionLine lineColorGold"></div>
          </div>
        ))}
      </div>

      {/* Section 6 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn brown">6.</span>
          <span className="st brown">Safety and Legal Disclosure</span>
        </h4>

        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
              If a user threatens harm to themselves or others, Orter reserves the right 
              to contact emergency services or law enforcement as required by law.
            </p>
            <div className="secionLine lineColorBrown"></div>
          </div>
        ))}
      </div>
      
      {/* Section 7 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn red">7.</span>
          <span className="st red">Children’s Privacy</span>
        </h4>

        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
              We do not knowingly collect information from children under 18. Accounts found to belong to minors will be removed.
            </p>
            <div className="secionLine lineColorRed"></div>
          </div>
        ))}
      </div>

      {/* Section 8 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn pink">8.</span>
          <span className="st pink">Changes to This Policy</span>
        </h4>

        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
              We may update this Privacy Policy at any time. The effective date will always be indicated at the top of the page.
            </p>
            <div className="secionLine lineColorPink"></div>
          </div>
        ))}
      </div>
    </div>
    <Footer />
    </>
  );
};

export default PrivacyPolicy;
